import { useEffect, useState } from 'react';

import { IHirer, IPageResult } from 'common/models';
import { UserManagementServices } from 'admin/services';

export const useHirer = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [queryOptions, setQueryOptions] = useState({});
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 15,
  });
  const [hirerResults, setHirerResults] = useState<IPageResult<IHirer>>({
    data: [],
    total: 0,
  });

  useEffect(() => {
    const queryParams = new URLSearchParams({
      page: (paginationModel.page + 1).toString(),
      pageSize: paginationModel.pageSize.toString(),
      ...queryOptions,
    });
    setIsLoading(true);
    UserManagementServices.getHirers(queryParams.toString())
      .then((res) => setHirerResults(res))
      .catch((err) => console.error(err))
      .finally(() => setIsLoading(false));
  }, [paginationModel.page, paginationModel.pageSize, queryOptions]);

  return {
    hirerResults,
    isLoadingHirers: isLoading,
    paginationModel,
    setPaginationModel,
    setQueryOptions,
  };
};
